import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import { ReactComponent as ArrowIcon } from 'icons/components/arrow.svg';

import './index.less';
import './themes/default.less';

const daysArray = [1, 2, 3, 4, 5, 6, 7];

export default class Calendar extends MainComponent {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            value: props.value || props.defaultValue,
            selected: props.selected || props.defaultValue,
        };
    }

    static propTypes = {
        value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
        defaultValue: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
        selected: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
        onChange: PropTypes.func,
        showArrows: PropTypes.bool,
        futureOff: PropTypes.bool,
        pastOff: PropTypes.bool,
        interval: PropTypes.number,
        selectedDays: PropTypes.array,
    };

    static defaultProps = {
        value: "",
        defaultValue: "",
        selected: "",
        onChange: null,
        showArrows: true,
        futureOff: false,
        pastOff: false,
        interval: 1,
        selectedDays: [],
    };

    get value() {
        return this.state.value;
    }

    changeMonth(flag) {
        const newDate = this._helper.date.addMonth(this.state.value, flag);
        this.setState({ value: newDate });

        if (this.props.onMonthChange)
            this.props.onMonthChange(newDate);
    }

    changeDate(date) {
        let selected = date;
        if (this.props.dateMode === "week") {
            const { startOfWeek } = this._helper.date.getWeek(date);
            selected = startOfWeek;
        }
        this.setState({ value: date, selected });

        if (this.props.onChange)
            this.props.onChange(date);
    }

    getDates(date) {
        date = new Date(date ? date.getTime() : (new Date()).getTime());
        date.setDate(1);
        date.setHours(0, 0, 0, 0);

        const dateTo = new Date(date.getTime());
        dateTo.setMonth(dateTo.getMonth() + 1);
        dateTo.setDate(dateTo.getDate() - 1);

        const day = date.getDay();
        const dayTo = dateTo.getDay();
        const daysMinus = (day === 0 ? 7 : day) - 1;
        const daysToPlus = 7 - (dayTo === 0 ? 7 : dayTo);

        date.setDate(date.getDate() - daysMinus);
        dateTo.setDate(dateTo.getDate() + daysToPlus);

        const rowsCount = Math.ceil((dateTo.getTime() - date.getTime()) / this._helper.date.msInDay / 7);

        date.setDate(date.getDate() - 1);

        return { date, rowsCount };
    }

    insertCell(date, currDate, valueDate, key, interval) {
        const { futureOff, pastOff, selectedDays } = this.props;
        const selected = this.props.selected || this.state.selected;

        const day = (date || new Date()).getDate();
        const isCurrent = ((date || new Date()).getFullYear() === (valueDate || new Date()).getFullYear() && (date || new Date()).getMonth() === (valueDate || new Date()).getMonth());
        const isToday = this._helper.date.equealDates((date || new Date()), currDate);

        let isSelectDate = false;
        if (isCurrent && selected?.getTime) {
            for (let i = 0; i < interval; i++) {
                isSelectDate = this._helper.date.equealDates(date, this._helper.date.addDays(selected, i));
                if (isSelectDate)
                    break;
            }
        }

        const text = isCurrent ? day : "";
        const cl = ["cell", "rad4"];
        const fn = isCurrent ? this.changeDate.bind(this, new Date(date.getTime())) : null;
        const props = [];

        const off = (futureOff && date > new Date()) || (pastOff && date < new Date()) ? true : false;
        if (isCurrent && selectedDays.length) {
            selectedDays.forEach(obj => {
                if (this._helper.date.equealDates(obj.date, date)) {
                    if (obj.freeTime) {
                        cl.push("slotEmpty");
                        props["data-tooltip"] = "Есть время для записи";
                    } else {
                        cl.push("slotBusy");
                        props["data-tooltip"] = "Нет времени для записи";
                    }
                }
            });
        }

        if (isCurrent) {
            cl.push("hand");

            if (isSelectDate)
                cl.push("active");
            else if (isToday)
                cl.push("todaycell");
            else if (off)
                cl.push("off");
        }

        return (
            <div
                key={key}
                className={cl.join(" ")}
                onClick={off ? null : fn}
                {...props}
            >
                {text}
            </div>
        );
    }

    renderRows(dateValue, interval) {
        const { date, rowsCount } = this.getDates(dateValue);
        const currDate = new Date();
        const rows = [];

        for (let i = 0; i < rowsCount; i++) {
            rows.push(
                <div key={i} className="row flex between centerV">
                    {daysArray.map(j => {
                        date.setDate(date.getDate() + 1);
                        return this.insertCell(date, currDate, this.props.value || this.state.value, `${i}_${j}`, interval);
                    })}
                </div>
            );
        }

        return (
            <div className="text p1">
                {rows}
            </div>
        );
    }

    renderHeader(date) {
        const { showArrows, futureOff, pastOff } = this.props;

        //const foff = (futureOff && date.getMonth() + 1 > new Date().getMonth());
        const foff = (futureOff && date >= new Date());
        const loff = (pastOff && date.getMonth() - 1 < new Date().getMonth());
        //const cl = foff ? "off" : "";
        const onClick = foff ? null : this.changeMonth.bind(this, 1);
        const onClick2 = loff ? null : this.changeMonth.bind(this, -1);

        return (
            <div>
                <div className="header flex centerV">
                    {showArrows && <ArrowIcon className={`arrow rotate180 hand ${loff ? "off" : ""}`} onClick={onClick2} />}
                    <div className="text p1SemiBold flex1 firstUpper">{this._helper.date.toStr(date, 'MMMM, YYYY')}</div>
                    {showArrows && <ArrowIcon className={`arrow hand ${foff ? "off" : ""}`} onClick={onClick} />}
                </div>
                <div className="header row flex between text p1">
                    {this._helper.date.weekNamesShort.map(it =>
                        <div key={it} className="firstUpper">{it}</div>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { interval } = this.props;
        const value = this.props.value || this.state.value;

        return (
            <div
                ref={el => this.domNode = el}
                className="calendar"
            >
                {this.renderHeader(value)}
                {this.renderRows(value, interval)}
            </div>
        );
    }
}
